import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {ConfigProvider} from "antd";
import React from "react";
import ReactDOM from "react-dom/client";
import {nlrmTheme} from "@nlrm/ui";
import {PortalApp} from "./PortalApp";
import "./portal.css";

const queryClient = new QueryClient({defaultOptions: {queries: {staleTime: 15_000, retry: false}}});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ConfigProvider theme={nlrmTheme}>
      <QueryClientProvider client={queryClient}>
        <PortalApp />
      </QueryClientProvider>
    </ConfigProvider>
  </React.StrictMode>,
);

